export const iconFontAwesomeCommunicationPhoneFlip = (
	<i className="fa-solid fa-phone-flip"></i>
);
